import { render, staticRenderFns } from "./BSpinner.vue?vue&type=template&id=4d28a64a&scoped=true&"
import script from "./BSpinner.vue?vue&type=script&lang=js&"
export * from "./BSpinner.vue?vue&type=script&lang=js&"
import style0 from "./BSpinner.vue?vue&type=style&index=0&id=4d28a64a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d28a64a",
  null
  
)

export default component.exports